import React, { Component } from 'react';
import { Select ,Checkbox,Row,Tag} from 'antd';
import Title from 'antd/lib/typography/Title';
import Text from 'antd/lib/typography/Text';

const month_list = [
    {
        text: "JAN",
        value: 1
    },
    {
        text: "FEB",
        value: 2
    },
    {
        text: "MAR",
        value: 3
    },
    {
        text: "APR",
        value: 4
    },
    {
        text: "MAY",
        value: 5
    },
    {
        text: "JUN",
        value: 6
    },
    {
        text: "JUL",
        value: 7
    },
    {
        text: "AUG",
        value: 8
    },
    {
        text: "SEP",
        value: 9
    },
    {
        text: "OCT",
        value: 10
    },
    {
        text: "NOV",
        value: 11
    },
    {
        text: "DEC",
        value: 12
    }
]
const month_init = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

const day_of_week_list = [
    {
        text: "MON",
        value: 0
    },
    {
        text: "TUE",
        value: 1
    },
    {
        text: "WED",
        value: 2
    },
    {
        text: "THU",
        value: 3
    },
    {
        text: "FRI",
        value: 4
    },
    {
        text: "SAT",
        value: 5
    },
    {
        text: "SUN",
        value: 6
    },
]
const day_of_week_init = [0, 1, 2, 3, 4, 5, 6]

const day_list = [];
const day_list_init = [];

for (let i = 1; i < 32; i++) {
    day_list.push({
        text: String(i).padStart(2, '0'),
        value: i
    });
    day_list_init.push(i)
}

let hour_list = [];
const hour_list_init = [];
for (let i = 0; i < 24; i++) {
    let hr = i <= 12 ? i : (i - 12);
    hour_list.push({
        text: `${String(hr==0?12:hr).padStart(2, '0')} ${i<12 ? "AM" : "PM"}`,
        value: i
    });
    hour_list_init.push(i)
}


const minute_list = [
    {
        text: "00 Min",
        value: 0
    },
    {
        text: "15 Min",
        value: 14
    },
    {
        text: "30 Min",
        value: 29
    },
    {
        text: "45 Min",
        value: 44
    }
];
const minute_list_init = [0, 14, 29, 44];



export const schedule_options = {
    'every_year': {
        text: "Yearly",
        defaultParams: {
            month:"1",
            day:"1",
            hour:"1",
            minute:"0"
        },
        supported_keys: ['month', 'day', 'hour', 'minute']
    },
    'every_month': {
        text: "Monthly",
        defaultParams: {
            day:"1",
            hour:"1",
            minute:"0"
        },
        supported_keys: ['day', 'hour', 'minute']
    },
    'every_week': {
        text: "Weekly",
        defaultParams: {
            day_of_week:"1",
            hour:"1",
            minute:"0"
        },
        supported_keys: ['day_of_week', 'hour', 'minute']
    },
    'every_day': {
        text: "Daily",
        defaultParams: {
            hour:"1",
            minute:"0"
        },
        supported_keys: ['hour', 'minute']
    },
    'every_hour': {
        text: "Hourly",
        defaultParams: {
            minute:"0"
        },
        supported_keys: ['minute']
    }
}

export const schedule_params = {
    'month': {
        data: month_list,
        init_data: month_init,
        title: "Select Month"
    },
    'day': {
        data: day_list,
        init_data: day_list_init,
        title: "Select Days"

    },
    'hour': {
        data: hour_list,
        init_data: hour_list_init,
        title: "Select Hours"

    },
    'day_of_week': {
        data: day_of_week_list,
        init_data: day_of_week_init,
        title: "Select Days of Week"

    },
    'minute': {
        data: minute_list,
        init_data: minute_list_init,
        title: "Select Minutes"

    }
}

class ScheduleChanger extends Component {


    // handleDaysOfWeekChanged = (value, checked) => {
    //     let form_data = this.state.form_data;
    //     if (!form_data.schedule) {
    //       form_data.schedule = {}
    //     }
    //     let day_of_weeks = form_data.schedule.day_of_week || [];
    //     if (day_of_weeks === "*") {
    //       day_of_weeks = day_of_week_init
    //     }
    //     console.log("month is ", day_of_weeks)
    //     let next_day_of_weeks = checked ? [...day_of_weeks, value] : day_of_weeks.filter(t => t !== value);
    //     if (next_day_of_weeks.length === day_of_week_list.length) {
    //       next_day_of_weeks = "*"
    //     }
    //     form_data.schedule.day_of_week = next_day_of_weeks;
    //     this.setState({
    //       form_data: form_data
    //     })
    //   }

    paramUpdater = (key, value, checked) => {
        let params = this.props.schedule.params || {};
        let keyObj = schedule_params[key];

        let initValues = params[key] || "";

        if (initValues === "*") {
            initValues = keyObj.init_data
        } else if(initValues===""){
            initValues=[]
        }
        else{
            initValues = initValues.split(",")
        }

        // filter all empty item
        initValues.filter(t => t !== "");


        let finalValues = checked ? [...initValues, value.toString()] : initValues.filter(t => t !== value.toString());

        // console.log("new params",finalValues)

        let finalStringValue = finalValues.join(",");
        this.paramAssigner(finalStringValue, key)


    }


    valueChanger = (value, key) => {
        let schedule = this.props.schedule;
        schedule[key] = value
        // make some change

        // console.log("/".split("/"))

        // send change 
        typeof this.props.onChange === 'function' && this.props.onChange(schedule);
    }
    paramAssigner = (value, key) => {
        let schedule = this.props.schedule;
        if (!schedule.params) {
            schedule['params'] = {}
        }
        schedule.params[key] = value
        // make some change


        // send change 
        typeof this.props.onChange === 'function' && this.props.onChange(schedule);
    }
    render() {
        let schedule = this.props.schedule || {};
        let type = schedule.type;
        let params = schedule.params || {};

        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column'
            }}>

                <Select
                    placeholder={"Schedule Type"}
                    value={type}
                    allowClear
                    onChange={(value) => {
                        // console.log("changed", value);
                        this.valueChanger(value, 'type')
                        let defaultParams=(schedule_options[value]&&schedule_options[value].defaultParams)||{};
                        this.valueChanger(defaultParams,'params')
                    }}
                >
                    {Object.keys(schedule_options).map((key, index) => {
                        let item = schedule_options[key];
                        return <Select.Option value={key} key={key} >{item.text}</Select.Option>
                    })}
                </Select>
                <br></br>
                {type&&
                <Text type='secondary'>Schedule Params</Text>
                }

                {schedule_options[type] && schedule_options[type].supported_keys.map((s_key, index) => {

                    let valueObj=schedule_params[s_key];
                    let valueData=valueObj.data||[];

                    let values=params[s_key]||"";
                    if(values==="*"){
                        values=valueObj.init_data;
                    }else{
                        values=values.split(",").filter(t=>t!=="").map((t)=>parseInt(t))
                        // console.log("VALUEs",values)

                    }

                    // console.log("param is ",params[s_key]==="*",s_key)

                    return <div>
                        <br></br>
                        <div>
                            <Row type='flex' justify='space-between' style={{
                                maxWidth: 400
                            }}>
                                <Text underline strong style={{
                                    fontSize: 16
                                }}>{valueObj.title}</Text><br></br>
                                <Checkbox checked={s_key==='minute'? (params[s_key]=="0,14,29,44"):(params[s_key] == "*")}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            this.paramAssigner(s_key==='minute'?"0,14,29,44":"*",s_key)
                                        } else {
                                            this.paramAssigner("",s_key)
                                        }
                                    }}
                                >Select All</Checkbox>
                            </Row>
                            <div style={{ display: 'block', maxWidth: 300, marginTop: 10 }}>

                                {valueData.map((item) => {

                                    return <Tag.CheckableTag
                                        key={item.value}
                                        style={{
                                            paddingLeft: 4,
                                            paddingRight: 4,
                                            margin:2
                                        }}
                                        checked={(Array.isArray(values) && values.indexOf((item.value)) > -1) }
                                        onChange={checked => this.paramUpdater(s_key,(item.value),checked)}
                                    >
                                        {item.text}
                                    </Tag.CheckableTag>
                                }
                                )}
                            </div>
                        </div>
                    </div>
                })}
            </div>
        );
    }
}

export default ScheduleChanger;
